export default {
  ICON_PLUS: 'fas fa-plus',
  ICON_TRASH: 'fas fa-trash',
  ICON_EYE: 'fa fa-eye',
  ICON_EDIT: 'fa fa-edit',
};
